/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'
import classnames from 'classnames'
import React from 'react'

const TextInputArea = props => {
  const { className, onChange, value, placeholder } = props

  return (
    <textarea
      type="text"
      autoComplete="off"
      rows="5"
      className={classnames(className)}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  )
}

TextInputArea.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
}

export default TextInputArea
